// extracted by mini-css-extract-plugin
export default {"main":"CalculatorStatic_main__deizR","mytestHeader":"CalculatorStatic_mytestHeader__A4AGk","editA":"CalculatorStatic_editA__3LJ+u"};